<template>
  <div>
    <v-tooltip
      top
      max-width="250px"
      content-class="light-tooltip"
    >
      <template #activator="{ on, attrs }">
        <div
          class="d-flex flex-column justify-content-center align-items-center py-2 text-center"
          v-bind="attrs"
          v-on="on"
          @click="onClick"
        >
          <span 
            class="font-weight-bolder font-9 text-nitro m-0 rounded-circle d-flex justify-content-center align-items-center border"
            style="width: 33px; height: 33px; cursor: pointer;"
            :class="{
              'white--text' : cycle.challenge && cycle.challenge.finished_at,
              'border-nitro' : (cycle.challenge && cycle.challenge.finished_at) || cycle.challenge_released,
              'bg-nitro' : (cycle.challenge && cycle.challenge.finished_at),
              'bg-challenge-gray' : !cycle.challenge || (!cycle.challenge.finished_at && !cycle.is_current) || (!cycle.challenge_released && cycle.is_current),
            }"
          >
            {{ cycle.challenge && cycle.challenge_result_released && cycle.started ? `${cycle.performance}%` : '-' }}
          </span>
          <p
            class="font-weight-bold font-9 m-0"
            :class="{
              'dark-gray-text': !cycle.challenge,
              'nitro--text': cycle.challenge,
            }"
          >
            Desafio
          </p>
        </div>
      </template>
      <!-- se o ciclo terminou e não realizou o desafio -->
      <div
        v-if="cycle.is_finished && (!cycle.challenge || !cycle.challenge.finished_at)"
        class="font-11"
      >
        <p class="text-center m-0 font-11">
          Você não realizou o desafio do ciclo
        </p>
      </div>
      <!-- se o ciclo não iniciou -->
      <div
        v-else-if="!cycle.started"
        class="font-11"
      >
        <p class="text-center m-0 font-11">
          Este ciclo de estudos ainda não está disponível
        </p>
      </div>
      <div
        v-else-if="cycle_started_and_challenge_not_released && !challenge_is_finished"
        class="font-11"
      >
        <p
          v-if="cycle.release_challenge == 'after_finish_modules' && cycle.module_progress < 100"
          class="m-0 font-11 font-weight-semibold"
        >
          O desafio ainda não está disponível. 
          Finalize os módulos para liberar o desafio.
        </p>
        <p
          v-else
          class="m-0 font-11"
        >
          O desafio ainda não está disponível. Aguarde a liberação no dia {{ $moment(cycle.begin_challenge_apply).format("DD/MM/YYYY [às] HH:mm") }}
        </p>
      </div>
      <div v-else-if="cycle_started_and_challenge_finished">
        <p class="m-0 font-12">
          <span class="font-weight-semibold">
            Desafio - <span class="font-weight-semibold">{{ cycle.challenge.count_questions }} questões</span> 
          </span>
          <br>
          <span>
            <img
              src="/images/tooltip_module_gray_icons/local.png"
              class="img-icon"
            > <span class="font-weight-semibold">{{ cycle.challenge_status_text }}</span>
          </span>
          <br>
          <span class="font-weight-regular font-11">
            <img
              src="/images/tooltip_module_gray_icons/calendar.svg"
              class="img-icon"
            > <span class="font-11">{{ $moment(cycle.begin_challenge_apply).format("DD/MM") }} a {{ $moment(cycle.end_challenge_apply).format("DD/MM") }}</span>
          </span>
          <br>
          <span class="font-weight-regular">
            <img
              src="/images/tooltip_module_gray_icons/local.png"
              class="img-icon"
            >Aplicação {{ cycle.challenge_type == 'print' ? 'impressa' : 'online' }}</span>
          <br>
          <span v-if="cycle.challenge_result_released">
            <img
              src="/images/tooltip_module_gray_icons/check.svg"
              class="img-icon"
            >  <span class="font-11">{{ cycle.performance }}%</span> desempenho
          </span>
          <span v-if="cycle.challenge && cycle.challenge.finished_at && !cycle.challenge_result_released">
            <img
              src="/images/tooltip_module_gray_icons/check.svg"
              class="img-icon"
            > Liberação do resultado em {{ $moment(cycle.release_challenge_result_at).format("DD/MM/YYYY") }}
          </span>
          <br>
          <span v-if="cycle.challenge_result_released">
            <img
              src="/images/tooltip_module_gray_icons/check.svg"
              class="img-icon"
            > 
            <span class="font-11">{{ cycle.challenge.hits }}/{{ cycle.challenge.count_questions }}</span> acertos
          </span>
        </p>
      </div>
      <div v-else-if="cycle.finished && (cycle.challenge || !cycle.challenge.finished_at)">
        <p class="m-0">
          Você não realizou o desafio do ciclo
        </p>
      </div>
      <div v-else-if="cycle.started && (!cycle.challenge || (cycle.challenge && !cycle.challenge.finished_at))">
        <p class="m-0 font-weight-normal">
          <span>
            Desafio: <span class="font-weight-bold">{{ count_questions }} questões</span>
          </span>
          <br>
          <span>
            <img
              src="/images/tooltip_module_gray_icons/local.png"
              class="img-icon"
            > <span class="font-weight-semibold font-11">{{ cycle.challenge_status_text }}</span>
          </span>
          <br>
          <span class="font-weight-regular font-11">
            <img
              src="/images/tooltip_module_gray_icons/calendar.svg"
              class="img-icon"
            > <span class="font-11 font-weight-regular">{{ $moment(cycle.begin_challenge_apply).format("DD/MM") }} a {{ $moment(cycle.end_challenge_apply).format("DD/MM") }}</span>
          </span>
          <br>
          <span class="font-weight-regular font-11">
            <img
              src="/images/tooltip_module_gray_icons/local.png"
              class="img-icon"
            > Aplicação {{ cycle.challenge_type == 'print' ? 'impressa' : 'online' }}</span>
          <br>
        </p>
      </div>
    </v-tooltip>
    <v-dialog
      v-if="cycle.challenge_released && (!cycle.challenge || (!cycle.challenge.finished_at && !cycle.challenge.started_at))"
      v-model="showStartScreen"
      max-width="1000"
      persistent
      value="true"
    >
      <StartScreen
        :cycle="cycle"
        @cancel="showStartScreen = false"
      />
    </v-dialog>
  </div>
</template>

<script>
import { mapMutations, mapActions } from 'vuex';
import { studyNowRouteName } from '@/student/constants/routes';
import StartScreen from '@/student/components/challenge/StartScreen.vue';
export default {
  components: { StartScreen},
    props:{
        cycle: {
            required: true,
            type: Object,
        }
    },
    data(){
        return {
          studyNowRouteName,
          showStartScreen: false,
        }
    },
    computed:{
      /*/ Verifica se o desafio foi finalizado e o resultado liberado /*/
      challenge_finished_and_result_released(){
        return this.cycle.challenge && this.cycle.challenge.finished_at && this.cycle.challenge_result_released
      },
      /*/ Verifica se o desafio foi finalizado e o resultado não liberado /*/
      challenge_finished_and_result_not_released(){
        return !this.challenge_finished_and_result_released
      },
      cycle_started_and_challenge_not_released(){
        return this.cycle.started && !this.cycle.challenge_released
      },
      cycle_started_and_challenge_released(){
        return this.cycle.started && this.cycle.challenge_released 
      },
      cycle_not_started_and_challenge_released(){
        return !this.cycle.started && this.cycle.challenge_released 
      },
      cycle_started_and_challenge_finished(){
        return this.cycle.started && this.cycle.challenge && this.cycle.challenge.finished_at
      },
      count_questions(){
        return this.cycle.challenge ? this.cycle.challenge.count_questions : this.cycle.count_questions
      },
      challenge_is_finished(){
        return this.cycle.challenge && this.cycle.challenge.finished_at
      },
    },
    methods: {
      ...mapActions(['createChallenge']),
      ...mapMutations(['SET_CYCLE']),
        onClick(){

          if(this.cycle.challenge_released && !this.cycle.challenge){
            this.createChallenge({ cycle_config_id: this.cycle.id })
            .then(() => {
              this.SET_CYCLE(this.cycle)
              this.showStartScreen = true;
            })
            return;
          }

          /** Se o desafio foi liberado e não iniciado, abre o modal de início do desafio **/
          if(this.cycle.challenge_released && !this.cycle.challenge.finished_at && !this.cycle.challenge.started_at && !this.cycle.is_finished){
            this.showStartScreen = true;
            return;
          }

          if(this.cycle.challenge && this.cycle.challenge.started_at && !this.cycle.challenge.finished_at){
            this.$router.push({ name: 'challenge.index', params: { challenge_id: this.cycle.challenge.id } })
            return
          }

          if(this.cycle.challenge && this.cycle.challenge.finished_at){
            if(!this.cycle.challenge_result_released){
              this.$notify({
                type: 'warning',
                message: 'O resultado do desafio ainda não está disponível.',
              });
              return;
            }
            this.SET_CYCLE(this.cycle)
            this.$router.push({ name: 'student.metric.index', query: { cycle_config_id: this.cycle.id } })
            return
          }
          
        }
    },
    
}
</script>
<style scoped>
  .bg-challenge-gray{
    background-color: #bdbdbd !important;
  }
  .img-icon{
    width: 14px;
    height: 14px;
  }
</style>

